export default __webpack_public_path__ + "static/15-300bfde6c164c76be963bc07e1fd38cd.jpg";